import React from 'react'

function SelectComparablePropertySkeleton() {
  return (
    <div className="relative h-full w-full bg-white">
      <div className="flex h-full w-full items-center justify-center">
        <p className="text-center text-3xl">Select a property to compare</p>
      </div>
      <div className="absolute bottom-8 right-5 flex flex-col gap-2 self-end">
        <div className="ml-auto h-[26px] w-[96px] rounded bg-[#EEEEEE]"></div>
        <div className="ml-auto h-[26px] w-[135px] rounded bg-[#EEEEEE]"></div>
        <div className="my-1 h-[56px] w-[360px] rounded bg-[#EEEEEE]"></div>
        <div className="flex gap-6">
          <div className="flex flex-col gap-2">
            <div className="h-[24px] w-[135px] rounded bg-[#EEEEEE]"></div>
            <div className="h-[24px] w-[155px] rounded bg-[#EEEEEE]"></div>
            <div className="h-[24px] w-[125px] rounded bg-[#EEEEEE]"></div>
            <div className="h-[24px] w-[140px] rounded bg-[#EEEEEE]"></div>
          </div>
          <div className="flex flex-col gap-2">
            <div className="h-[24px] w-[135px] rounded bg-[#EEEEEE]"></div>
            <div className="h-[24px] w-[155px] rounded bg-[#EEEEEE]"></div>
            <div className="h-[24px] w-[125px] rounded bg-[#EEEEEE]"></div>
            <div className="h-[24px] w-[140px] rounded bg-[#EEEEEE]"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SelectComparablePropertySkeleton
